<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->

<mat-card *ngIf="whoYou$ | async as whoYou" class="who-you">
	<mat-card-content>
		Morphed as: <span class="user-information">{{ whoYou }}</span>
	</mat-card-content>
	<mat-card-actions align="end">
		<button mat-flat-button color="primary" (click)="signOut()">Done</button>
	</mat-card-actions>
</mat-card>
